export const INVALID_DOMAINS = Object.freeze([
  "@gmail.",
  "@yahoo.",
  "@hotmail.",
  "@live.",
  "@aol.",
  "@outlook.",
  "@comcast.",
  "@inbox.",
  "@icloud.",
  "@mail.com"])



// WEBPACK FOOTER //
// ./src/constants/InvalidEmailDomains/index.js